import FocusLock from 'react-focus-lock';
import { CloseButton } from '@jsluna/button';
import { ClickAway, filterProps, setHasOverlay, onKeyPress, getUniqueId } from '@jsluna/utils';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Heading } from '@jsluna/typography';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var ModalHeading = function ModalHeading(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(Heading, _extends({}, props, {
    className: classnames('ln-c-modal__heading', className)
  }));
};

ModalHeading.propTypes = {
  className: PropTypes.string
};
ModalHeading.defaultProps = {
  className: undefined
};
ModalHeading.displayName = 'ModalHeading';
ModalHeading.propTypes = {
  className: PropTypes.string
};
ModalHeading.defaultProps = {
  className: undefined
};

var Modal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Modal, _Component);

  function Modal(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleEscapePress = onKeyPress([{
      name: 'Escape',
      code: 27
    }], function () {
      _this.onClose();
    });
    _this.headingId = props.headingId || getUniqueId('modal-');
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind(_assertThisInitialized(_this));
    _this.handleOverlayStateChange = _this.handleOverlayStateChange.bind(_assertThisInitialized(_this));
    _this.setEscapeListener = _this.setEscapeListener.bind(_assertThisInitialized(_this));
    _this.removeEscapeListener = _this.removeEscapeListener.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var open = this.props.open;
    this.handleOverlayStateChange();

    if (open) {
      this.setEscapeListener();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    if (prevProps.open !== open) {
      this.handleOverlayStateChange(open);

      if (open) {
        this.setEscapeListener();
      } else {
        this.removeEscapeListener();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var open = this.props.open;

    if (open) {
      this.handleOverlayStateChange(false);
    }

    this.removeEscapeListener();
  };

  _proto.onClose = function onClose() {
    var _this$props = this.props,
        handleClose = _this$props.handleClose,
        open = _this$props.open;

    if (open && handleClose) {
      handleClose();
    }
  };

  _proto.setEscapeListener = function setEscapeListener() {
    var restrictClose = this.props.restrictClose;

    if (!restrictClose) {
      document.addEventListener('keydown', this.handleEscapePress, false);
    }
  };

  _proto.removeEscapeListener = function removeEscapeListener() {
    var restrictClose = this.props.restrictClose;

    if (!restrictClose) {
      document.removeEventListener('keydown', this.handleEscapePress, false);
    }
  };

  _proto.handleCloseButtonClick = function handleCloseButtonClick(e) {
    var closeElement = this.props.closeElement;
    this.onClose();

    if (closeElement && closeElement.onClick) {
      closeElement.onClick(e);
    }

    e.stopPropagation();
  };

  _proto.handleOverlayStateChange = function handleOverlayStateChange(openState) {
    var _this$props2 = this.props,
        setHasOverlay$$1 = _this$props2.setHasOverlay,
        open = _this$props2.open;
    setHasOverlay$$1(typeof openState === 'boolean' ? openState : open);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        alert = _this$props3.alert,
        children = _this$props3.children,
        className = _this$props3.className,
        closeElement = _this$props3.closeElement,
        element = _this$props3.element,
        fullScreen = _this$props3.fullScreen,
        handleClose = _this$props3.handleClose,
        hideCloseButton = _this$props3.hideCloseButton,
        open = _this$props3.open,
        preventFocus = _this$props3.preventFocus,
        restrictClose = _this$props3.restrictClose,
        small = _this$props3.small,
        rest = _objectWithoutPropertiesLoose(_this$props3, ["alert", "children", "className", "closeElement", "element", "fullScreen", "handleClose", "hideCloseButton", "open", "preventFocus", "restrictClose", "small"]);

    var Element = element;
    var describedBy;
    React.Children.forEach(children, function (child) {
      if (child.type && child.type === ModalHeading) {
        describedBy = _this2.headingId;
      }
    });
    return /*#__PURE__*/React.createElement(Element, _extends({}, filterProps(rest, ['setHasOverlay', 'handleClose', 'headingId']), {
      role: alert ? 'alertdialog' : 'dialog',
      className: classnames(className, 'ln-c-modal', {
        'is-open': open,
        'ln-c-modal--small': small,
        'ln-c-modal--full-screen': fullScreen
      }),
      hidden: !open,
      "aria-describedby": describedBy
    }), open && /*#__PURE__*/React.createElement(ClickAway, {
      inactive: restrictClose,
      onClickAway: function onClickAway() {
        return _this2.onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ln-c-modal__body"
    }, /*#__PURE__*/React.createElement(FocusLock, {
      returnFocus: true,
      autoFocus: !preventFocus
    }, /*#__PURE__*/React.createElement("div", {
      className: "ln-c-modal__scroll-area"
    }, React.Children.map(children, function (child) {
      return child.type && child.type === ModalHeading ? React.cloneElement(child, {
        id: describedBy
      }) : child;
    })), !hideCloseButton && !restrictClose && /*#__PURE__*/React.createElement(CloseButton, {
      onClick: this.handleCloseButtonClick,
      element: closeElement,
      innerRef: function innerRef(el) {
        _this2.closeButtonEl = el;
      }
    })))));
  };

  return Modal;
}(Component);

Modal.propTypes = {
  /** Sets the role to `alertdialog` for additional screen reader context - use when user action is required */
  alert: PropTypes.bool,

  /** Modal contents. Include `ModalHeading` to apply `aria-describedby` to container */
  children: PropTypes.node.isRequired,

  /** Set a custom class name to the `.ln-c-modal` element */
  className: PropTypes.string,

  /** Used to customise the `CloseButton` element for example if it should be a react-router `Link` */
  closeElement: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

  /** Allows the top-level element to be customized */
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),

  /** When applied the modal will take up the full screen on small screens, has no affect on larger screens */
  fullScreen: PropTypes.bool,

  /** Function to control the `open` prop from outside of the component */
  handleClose: PropTypes.func,

  /** Id that gets used on the `ModalHeading` component if preset for `aria-labelledby` functionality. Will be autogenerated if left blank so set if using SSR */
  headingId: PropTypes.string,

  /** Apply prop to not show the 'x' dismiss button in the top right. The modal will still be dismissable by the escape key or clicking away */
  hideCloseButton: PropTypes.bool,

  /** Controls whether the modal is visible or not */
  open: PropTypes.bool,

  /** By default focus will sit on the first focusable element in the modal, this can be toggled off but isn't recommended as it's preferable for SSR and keyboard a11y */
  preventFocus: PropTypes.bool,

  /** Prevents the modal from being closed by either the escape key or clicking on the overlay. Also provides the effects of `hideCloseButton` */
  restrictClose: PropTypes.bool,

  /** Prop to override the setting of the `has-overlay` class on the `body` element which prevents scolling of content behind the modal */
  setHasOverlay: PropTypes.func,

  /** When set the modal has a reduced max-width on large screen devices */
  small: PropTypes.bool
};
Modal.defaultProps = {
  alert: false,
  className: undefined,
  closeElement: undefined,
  element: 'div',
  fullScreen: false,
  handleClose: undefined,
  headingId: undefined,
  hideCloseButton: false,
  open: false,
  preventFocus: false,
  restrictClose: false,
  setHasOverlay: setHasOverlay,
  small: false
};
Modal.displayName = 'Modal';

export { Modal, ModalHeading };
//# sourceMappingURL=index.js.map
